module.exports = {"svg":{"$":{"width":"128","height":"128","xmlns":"http://www.w3.org/2000/svg"},"path":[{"$":{"d":"M96.258 57.462h31.421C124.794 27.323 100.426 2.956 70.287.07v31.422a32.856 32.856 0 0 1 25.971 25.97zm-38.796-25.97V.07C27.323 2.956 2.956 27.323.07 57.462h31.422a32.856 32.856 0 0 1 25.97-25.97zm12.825 64.766v31.421c30.46-2.885 54.507-27.253 57.713-57.712H96.579c-2.886 13.466-13.146 23.726-26.292 26.291zM31.492 70.287H.07c2.886 30.46 27.253 54.507 57.713 57.713V96.579c-13.466-2.886-23.726-13.146-26.291-26.292z"}}]}}


//////////////////
// WEBPACK FOOTER
// ./~/xml-loader!./src/svg/example.svg
// module id = 376
// module chunks = 0